// Dynamically determine the API Base URL
// If the app is running on a live domain, use the production API.
// Otherwise, fall back to localhost for development.

// Connect directly to the production SSL URL
export const API_BASE_URL = 'https://api.vaidyamedx.in';

console.log(`Connected to Backend: ${API_BASE_URL}`);
